import { Euler, Quaternion } from 'three';

export const OR_DUAL_QUCK_CHANGER_SHORTNAME = 'Dual Quick Changer';

/**
 * Collision box of the dual quick changer body itself, in the changer's mount
 * frame. Unlike every other gripper's collision box this one is not part of
 * the equipment configuration, so it cannot be read back off the config.
 *
 * The planner's copy of these numbers lives in the `connector_box_size` /
 * `connector_box_origin` properties of
 * `standard_bots_description/urdf/end_effectors/dual_quick_changer.xacro`, and
 * a third copy is hardcoded in OnRobotDualQuickChangerKinematics. Keep them in
 * agreement.
 */
export const OR_DUAL_QUICK_CHANGER_CONNECTOR_COLLISION_BOX = {
  origin: { x: 0, y: 0, z: 0.035 },
  size: { x: 0.0932, y: 0.127, z: 0.071 },
};

/**
 * Collision box the planner falls back to for a mounted gripper whose slot has
 * no box in the configuration — `computeDefaultBox` only derives one for a 2FG7
 * or 3FG15, so e.g. a 2FG14 lands here. Mirrors the `dqc_g1_box_size` /
 * `dqc_g1_box_origin` xacro args; the secondary slot is the same box mirrored
 * across X.
 */
export const OR_DUAL_QUICK_CHANGER_SLOT_FALLBACK_COLLISION_BOX = {
  primary: {
    origin: { x: 0.12, y: 0, z: 0 },
    size: { x: 0.1246, y: 0.1046, z: 0.1565 },
  },
  secondary: {
    origin: { x: -0.12, y: 0, z: 0 },
    size: { x: 0.1246, y: 0.1046, z: 0.1565 },
  },
};

const primaryRotation = new Quaternion().setFromEuler(
  new Euler(0, Math.PI / 3, 0),
);

const secondaryRotation = new Quaternion().setFromEuler(
  new Euler(0, -Math.PI / 3, 0),
);

export const OR_DUAL_QUICK_CHANGER_PRIMARY_POSE = {
  i: primaryRotation.x,
  j: primaryRotation.y,
  k: primaryRotation.z,
  w: primaryRotation.w,
  x: 0.0464,
  y: 0,
  z: 0.0638,
};

export const OR_DUAL_QUICK_CHANGER_SECONDARY_POSE = {
  i: secondaryRotation.x,
  j: secondaryRotation.y,
  k: secondaryRotation.z,
  w: secondaryRotation.w,
  x: -0.0464,
  y: 0,
  z: 0.0638,
};

/**
 * The tooltip option a loaded slot publishes. One speller, shared by
 * `getTCPOffsetOptions` and the editor that offers to make a slot active, so
 * the two cannot drift apart.
 */
export function dualQuickChangerTcpOffsetOption(
  slot: 'primary' | 'secondary',
): `ee-${string}` {
  return `ee-OnRobotDualQuickChanger-${slot}`;
}
